import React, { useState, useMemo, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Select } from "antd";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

const CountryCodePrompt = ({ visible, onClose, onConfirm, provider }) => {




  const [selectedCountryCode, setSelectedCountryCode] = useState("971");
  const [selectedTags, setSelectedTags] = useState([]);
  const [newTags, setNewTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [previousTags, setPreviousTags] = useState([]);
  const [removedTags, setRemovedTags] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const { tags } = useSelector((state) => state.tags);



  const handleDownload = () => {
    const data = [
      ["firstname", "lastname", "company", "designation", "emailaddresses", "phonenumbers", "status", "notes"],
      ["John",  "Doe",     "TechCorp",   "Software Engineer", "john.doe@example.com",     "+971 50 1234567", "interested",    "Met at conference"],
      ["Jane",  "Smith",   "DesignHub",  "Product Designer",  "jane.smith@example.com",   "+971 50 9876543", "called",        ""],
      ["Alice", "Johnson", "FinTech Ltd","Data Analyst",       "alice.johnson@example.com","+971 55 1122334", "notInterested", "Call back next week"],
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      data.map((row) => row.join(",")).join("\n");

    const downloadLink = document.createElement("a");
    downloadLink.href = encodeURI(csvContent);
    downloadLink.download = "sample.csv";
    downloadLink.click();
  };


  useEffect(() => {
    if (!visible) {
      setSelectedTags([]);
      setNewTags([]);
      setPreviousTags([]);
      setRemovedTags([]);
      setSelectedFile(null);
    }
  }, [visible]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleUserTags = (tags) => {

    setSelectedTags(tags);

    const removedTagsFilter = previousTags
      .filter((prevTag) => !tags.some((tag) => tag.value === prevTag.value))
      .map((tag) => tag.value);
    setRemovedTags(removedTagsFilter);
  };
  useEffect(() => {
    const filteredTags = tags.filter(
      (tag) => tag.tag_id && tag.tag && tag.emoji
    );
    const tagMap = filteredTags.map((tag) => ({
      value: tag.tag,
      label: `${tag.emoji} ${tag.tag}`,
      emoji: tag.emoji,
    }));
    setAllTags(tagMap);
  }, [tags]);
  // Generate country code options from libphonenumber-js
  const countryCodeOptions = useMemo(() => {
    const countries = getCountries();
    const countryMap = new Map();

    // Country name mapping for better labels
    const countryNames = {
      US: "USA",
      GB: "UK",
      AE: "UAE",
      SA: "Saudi Arabia",
      IN: "India",
      PK: "Pakistan",
      QA: "Qatar",
      KW: "Kuwait",
      OM: "Oman",
      BH: "Bahrain",
      EG: "Egypt",
      JO: "Jordan",
      LB: "Lebanon",
      CN: "China",
      JP: "Japan",
      KR: "South Korea",
      SG: "Singapore",
      MY: "Malaysia",
      AU: "Australia",
      DE: "Germany",
      FR: "France",
      IT: "Italy",
      ES: "Spain",
      CA: "Canada",
      MX: "Mexico",
      BR: "Brazil",
      AR: "Argentina",
      ZA: "South Africa",
      NG: "Nigeria",
      KE: "Kenya",
      TR: "Turkey",
      RU: "Russia",
      NL: "Netherlands",
      BE: "Belgium",
      SE: "Sweden",
      NO: "Norway",
      DK: "Denmark",
      FI: "Finland",
      PL: "Poland",
      CH: "Switzerland",
      AT: "Austria",
      IE: "Ireland",
      NZ: "New Zealand",
      TH: "Thailand",
      ID: "Indonesia",
      PH: "Philippines",
      VN: "Vietnam",
      IL: "Israel",
    };

    countries.forEach((countryCode) => {
      try {
        const dialCode = getCountryCallingCode(countryCode);
        const countryName = countryNames[countryCode] || countryCode;

        // Group countries with same dial code
        if (!countryMap.has(dialCode)) {
          countryMap.set(dialCode, {
            value: dialCode,
            label: `+${dialCode} (${countryName})`,
            countries: [countryName],
          });
        } else {
          const existing = countryMap.get(dialCode);
          existing.countries.push(countryName);
          existing.label = `+${dialCode} (${existing.countries.join(", ")})`;
        }
      } catch (e) {
        // Skip countries without calling codes
      }
    });

    // Convert to array and sort by dial code
    return Array.from(countryMap.values()).sort((a, b) => {
      return parseInt(a.value) - parseInt(b.value);
    });
  }, []);



  const handleConfirm = () => {
    onConfirm({
      countryCode: selectedCountryCode,
      tags: selectedTags,
      file: provider === "csvExcel" ? selectedFile : null,
      newTags
    });
  };



  const handleCreateTag = async (inputValue) => {
    setNewTags([...newTags, { tag: inputValue, emoji: "🏷️" }]);
    setSelectedTags([
      ...selectedTags,
      { value: inputValue, label: `🏷️ ${inputValue}`, emoji: "🏷️" },
    ]);
  };
  useEffect(() => {
    if (!visible) {
      setSelectedTags([]);
      setNewTags([]);
      setPreviousTags([]);
      setRemovedTags([]);
    }
  }, [visible]);

  return (
    <Modal
      show={visible}
      onHide={onClose}
      // onHide={handleClose}
      centered
      backdrop="static"
      className="country-code-modal"
      style={{ zIndex: 1500 }}
      backdropClassName="country-code-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Default Country Code & Tags</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>


          {provider === "csvExcel" && (
            <>

              <div className="uploadSectionContainer mb-4">
                <div className="uploadSectionInnerBox">
                  {/* <div className="uploadSectionImageBox">
          <ImageWithBasePath
            src="assets/img/customIcons/excelLogo.png"
            className="uploadSectionImage"
            alt="Excel Logo"
          />
        </div> */}

                  <div className="profile-upload d-block">
                    <div className="profile-upload-content">
                      <label className="profile-upload-btn">
                        <i className="ti ti-file-broken" /> Upload File
                        <input
                          type="file"
                          className="input-img"
                          accept=".xlsx,.csv"
                          onChange={handleFileChange}
                        />
                      </label>

                      {selectedFile && (
                        <p className="mt-2 text-success">
                          Selected: {selectedFile.name}
                        </p>
                      )}

                      <p>Only Excel / CSV file</p>
                    </div>
                  </div>

                  <p className="supportedFormat">
                    (Supported formats .xlsx, .csv; max file size 5 MB)
                  </p>

                  <p className="text-muted">
                    Download a{" "}
                    <span
                      onClick={handleDownload}
                      style={{ cursor: "pointer", color: "#2c5cc5" }}
                    >
                      sample CSV
                    </span>
                  </p>
                </div>
              </div>
            </>
          )}




          <Form.Group className="mb-3">
            <Form.Label>
              Select default country code for contacts without one
            </Form.Label>
            <Select
              style={{ width: "100%", zIndex: 1600 }}
              value={selectedCountryCode}
              onChange={(value) => setSelectedCountryCode(value)}
              options={countryCodeOptions}
              showSearch
              placeholder="Select country code"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
            <Form.Text className="text-muted">
              This country code will be applied to phone numbers that don't have
              one when importing from {provider}.
            </Form.Text>
          </Form.Group>


          <Form.Group className="mb-3">
            <Form.Label>Tags</Form.Label>
            <CreatableSelect
              classNamePrefix="react-select"
              options={allTags}
              value={selectedTags}
              onChange={(newValue) => handleUserTags(newValue)}
              onCreateOption={handleCreateTag}
              className="js-example-placeholder-multiple select2 js-states"
              isMulti={true}
              placeholder="Add Tags"
            />
            <Form.Text className="text-muted">
              Tags applied to every contact you import. Pick existing tags or type a new one and press enter to create it.
            </Form.Text>
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Continue Import
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CountryCodePrompt;
